export default __webpack_public_path__ + "static/wepiggy-dc5e1e6ac1e3b99523cfc9cd9d84d416.jpg";